import { CarCoverageType } from '~domain/model/quote/coverage';
import { TranslationKeys } from '~frontend-common/i18n/english/coverage.i18n';

const keys: TranslationKeys = {
  coverage: {
    core: {
      categorizedSelect: {
        categories: {
          base: 'Base',
          extended: 'Étendu',
        },
      },
    },
    car: {
      caregiver: {
        base: 'Blessures graves seulement',
        extended: 'Blessures graves et non graves',
      },
      funeral: {
        base: "25 000$ à votre époux, 10 000$ à chacun de vos dépendants et jusqu'à 6 000$ pour les frais funéraires.",
        extended:
          "50 000$ à votre époux, 20 000$ à chacun de vos dépendants et jusqu'à 8 000$ pour les frais funéraires.",
      },
      incomeReplacement: {
        base: '400$',
        extended: '{{0}}$',
      },
      medicalCatastrophicInjury: {
        base: '1M$',
        extended: '2M$',
      },
      medicalNonCatastrophicInjury: {
        base: '65 000$',
        extended: '{{0}}$',
      },
    },
    updateConfirmationPrompt: {
      description: {
        add: 'En ajoutant cette couverture, certaines protections extra seront ajoutées. Il est recommandé de réviser vos protections par la suite.',
        remove:
          "En supprimant cette couverture, d'autres protections seront supprimées. Il est recommandé de réviser vos protections par la suite.",
        [CarCoverageType.ThirdLiability_A]: {
          changeValue:
            'En modifiant la couverture de responsabilité civile pour ce véhicule, la couverture de responsabilité civile pour tous les véhicules sera également modifiée.',
        },
      },
      actions: {
        accept: 'Ok',
        cancel: 'Annuler',
      },
    },
  },
};

export default keys;
